import React, {useEffect, useState} from 'react';
import i18next from "../../languages/no/translation";
import axios from "axios";

const ReceiverTermModal = (props: any) => {

    let term_receiver_ajax_lock = false;

    const [receiverTerms, setReceiverTerms] = useState("");

    const getReceiverTermModal = () => {
        if (!term_receiver_ajax_lock) {
            term_receiver_ajax_lock = true;
            axios({
                url: "/receiver_terms",
                method: "get",
                headers: {
                    "Content-Type": "application/json"
                }
            })
                .then(function (response: any) {
                    const obj = response.data;
                    if (obj.term !== undefined) {
                        setReceiverTerms(obj.term);
                        props.enableReceiverTermCheckbox(true);
                    }
                    term_receiver_ajax_lock = false;
                })
                .catch(function (error: any) {
                    term_receiver_ajax_lock = false;
                });
        }
    }


    useEffect(() => {
        getReceiverTermModal();
    }, []);


    return (
        <>
            <div className="modal fade" id="receiver-term-modal" tabIndex={-1} aria-labelledby="exampleModalLabel"
                 aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title"
                                id="exampleModalLabel">{i18next.t('user.registration_form.user_term_title')}</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal"
                                    aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            <div className="col-12">
                                {receiverTerms}
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Lukk
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );

}

export default ReceiverTermModal;